export const getSearchEventData = (query) => {
    const limit = query.getRequest().getSearchLimit()
        ? query.getRequest().getSearchLimit()
        : query.getLastResponse()?.limit;
    const pageNumber = limit ? Math.floor((query.getRequest().getSearchOffset() || 0) / limit + 1) : 0;
    return {
        keyword: query.getRequest().getSearchQueryKeyphrase() || '',
        pageNumber: isNaN(pageNumber) ? undefined : pageNumber,
        pageSize: limit,
        numRequested: limit,
        numResults: query.getLastResponse()?.content?.length,
        totalResults: query.getLastResponse()?.total_item,
    };
};
